export enum eHreftype {
  /**
   * 跳转类型 0-无  2-三方连接 3-兑换码兑换
   */
  NO = 0,
  /**
   * 1-PC端内部
   */
  PC = 1,
  /**
   * 三方连接
   */
  THIRD = 2,
  /**
   * 兑换码兑换
   */
  CODE = 3,

  /**
   * 特殊商品
   */
  SP_GOODS = 4,
}
export enum eFilterType {
  /**
   * 按用户ID
   */
  BYUSERID = 1,
  /**
   *D 2按用户类型
   */
  BYTUSERYPE = 2,

  /**
   * 推荐码
   */
  REFERRAL_CODE = 3,

  /**
   * 安卓包渠道标
   */
  CHANNEL_IDEN = 4,
}

export enum eType {
  /**
   *  1-文字
   */
  LETTER = 1,
  /**
   * 2-图片
   */
  PICTURE = 2,
}

export interface iFilter {
  register_day_rule: iFilterRule;
  pay_amount_rule: iFilterRule;
  pay_count_rule: iFilterRule;
  district_rule: iDsitrictRule;
}
export interface iFilterRule {
  minimum: number | null;
  maxima: number | null;
  limit_type: number;
}
export interface iDsitrictRule {
  prov_id: number[];
  limit_type: number;
}
